var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDuoSaml(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    height: 20,
    viewBox: "0 0 285 92.9",
    width: 100,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M145,92h43.5V.5H145ZM0,92c48.32.48,90.52,2.66,92-43.5H0ZM193.5,48.5c-.24,57.15,91.55,57,91.5,0Z",
    fill: "#82C96A",
    transform: "translate(0 0.4)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0V44H92c-.17-11.36-4.56-18.92-9.5-25.5C66-3.49,38-.46,0,0ZM96.5,30c0,41.25,10.86,54.08,43.5,62.5q.25-46,.5-92L97,0Q96.75,15,96.5,30Zm126-27C206.05,9.37,195.38,23.41,193,44h92C285.09,14.45,253.79-9.12,222.5,3Z",
    fill: "#6EBF51",
    transform: "translate(0 0.4)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuoSaml);
export default __webpack_public_path__ + "static/media/DuoSAML.50cfcb7162d7c73560a8149dd75f404a.svg";
export { ForwardRef as ReactComponent };